// import copy from 'clipboard-copy'

export const doCopy = (text) => {
  // copy(text).then((res) => {
  //   console.log('success')
  // }).catch((err) => {
  //   console.log(err)
  // })
  // if (window.clipboardData) {
  //   window.clipboardData.setData('text', text)
  // } else {
  //   (function () {
  //     document.oncopy = function (e) {
  //       e.preventDefault()
  //       e.clipboardData.setData('text', text)
  //       // document.oncopy = null
  //     }
  //   })();
  //   document.execCommand('Copy');
  // }
  let $div = document.createElement('div')
  $div.setAttribute('class', 'copy-div')
  $div.innerText = text
  document.body.appendChild($div)

  const range = document.createRange();
  range.selectNode(document.querySelector(".copy-div"));
  const selection = window.getSelection();
  console.log(selection)
  if (selection.rangeCount > 0) selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('Copy');
  // document.removeChild($div)
  document.body.removeChild($div)
}

export const GetQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r !== null) return unescape(r[2])
  return null
}

export const offline = (that) => {
  window.addEventListener('offline', () => {
    that.$message('', that.$t('netErr'))
  })
}

export const trim = (s) => {
  let _s = s.replace(/^\s+|\s+$/, '')
  return _s
}


// WEBPACK FOOTER //
// ./src/utils.js